"use client";
import {price_format} from "@core/helpers/string";
import {useWebSiteContext} from "@core/helpers/client/contexts/WebSiteContext";
import {useMemo} from "react";

export const currency_symbols = {
	"1": 'تومان',
	"2": 'ریال',
	"3": '$',
};

const Index = ({price, icon_component,className}) => {
	const {web_site_setting: {web_site_currency}} = useWebSiteContext();
	const currency_symbol = useMemo(() => currency_symbols[web_site_currency], [web_site_currency]);

	return (
		<span className={`price-component ${className || ''}`}>
			<span className={"price-number"}>{price_format(price)}</span>
			{" "}
			<span className={"price-currency"}>{icon_component || currency_symbol}</span>
		</span>
	);
}

export default Index;